export function isAuthComplete(state: {
  logged: boolean;
  hasTermsAgreement: boolean;
  hasPhoneVerified: boolean;
  needsPhoneVerification: boolean;
}): boolean {
  return state.logged && state.hasTermsAgreement && !state.hasPhoneVerified === !state.needsPhoneVerification;
}
